module.exports = __webpack_public_path__ + "media/SoyNet_intro_english_caption.a83e2af3.mp4";